import React from 'react';
import { MarginPage } from './MarginPage';

export const RetailerMargins: React.FC = () => {
  return <MarginPage type="retailer" title="Retailer Margins" />;
};

export default RetailerMargins;
